var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "modalBk",
    staticClass: "modal-bk",
    on: {
      "click": _vm.handleCloseModal
    }
  }, [_c('div', {
    ref: "modalMain",
    staticClass: "autoPlay_modal",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "autoPlay_modal__title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("自動輪播設定")]), _c('v-switch', {
    attrs: {
      "dark": "",
      "inset": ""
    },
    model: {
      value: _vm.settings.openDemo,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "openDemo", $$v);
      },
      expression: "settings.openDemo"
    }
  })], 1), _c('div', {
    staticClass: "autoPlay_modal__contact",
    class: {
      'text-muted': !_vm.settings.openDemo
    }
  }, [_c('div', {
    staticClass: "time_setting"
  }, [_c('label', {
    staticClass: "time_setting__label"
  }, [_c('p', {
    staticClass: "tooltipText",
    attrs: {
      "data-tip": "\u81F3\u5C11 ".concat(_vm.IDLE_SECONDS_MIN, " \u79D2")
    }
  }, [_vm._v(" 閒置時間 ")]), _c('v-text-field', {
    staticClass: "numberInput",
    attrs: {
      "type": "number",
      "dense": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "dark": "",
      "min": _vm.IDLE_SECONDS_MIN,
      "max": _vm.SECONDS_MAX,
      "color": "situationRoom_blue",
      "disabled": !_vm.settings.openDemo
    },
    on: {
      "change": _vm.fixIdleSeconds
    },
    model: {
      value: _vm.settings.idleSeconds,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "idleSeconds", _vm._n($$v));
      },
      expression: "settings.idleSeconds"
    }
  }), _c('p', [_vm._v("秒")])], 1), _c('label', {
    staticClass: "time_setting__label"
  }, [_c('p', {
    staticClass: "tooltipText",
    attrs: {
      "data-tip": "\u81F3\u5C11 ".concat(_vm.INTERVAL_SECONDS_MIN, " \u79D2")
    }
  }, [_vm._v("輪播間隔")]), _c('v-text-field', {
    staticClass: "numberInput",
    attrs: {
      "type": "number",
      "dense": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "dark": "",
      "min": _vm.INTERVAL_SECONDS_MIN,
      "max": _vm.SECONDS_MAX,
      "color": "situationRoom_blue",
      "disabled": !_vm.settings.openDemo
    },
    on: {
      "change": _vm.fixIntervalSeconds
    },
    model: {
      value: _vm.settings.intervalSeconds,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "intervalSeconds", _vm._n($$v));
      },
      expression: "settings.intervalSeconds"
    }
  }), _c('p', [_vm._v("秒")])], 1)]), _c('div', {
    staticClass: "select_site"
  }, [_c('p', [_vm._v("選擇需要輪播的案場")]), _c('v-autocomplete', {
    staticClass: "numberInput w-100",
    attrs: {
      "items": _vm.allSiteOptions,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "solo": "",
      "flat": "",
      "chips": "",
      "deletable-chips": "",
      "attach": "",
      "clearable": "",
      "dark": "",
      "menu-props": {
        offsetY: true,
        dark: true
      },
      "disabled": !_vm.settings.openDemo,
      "placeholder": "選擇輪播案場",
      "error-messages": _vm.hasError ? ['請至少選擇一項'] : []
    },
    on: {
      "focus": function focus() {
        return _vm.isFocus = true;
      }
    },
    model: {
      value: _vm.settings.siteIds,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "siteIds", $$v);
      },
      expression: "settings.siteIds"
    }
  })], 1), _c('div', {
    staticClass: "autoPlay_modal__footer"
  }, [_c('button', {
    staticClass: "autoPlay_modal__btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.settings.openDemo
    },
    on: {
      "click": _vm.resetSettings
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": "",
      "small": ""
    }
  }, [_vm._v(" mdi-restore ")]), _c('p', {
    staticClass: "btn_text"
  }, [_vm._v("預設值")])], 1), _c('button', {
    staticClass: "autoPlay_modal__btn",
    attrs: {
      "type": "button",
      "disabled": _vm.hasError
    },
    on: {
      "click": _vm.submitSettings
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": "",
      "small": ""
    }
  }, [_vm._v(" mdi-content-save ")]), _c('p', {
    staticClass: "btn_text"
  }, [_vm._v("儲存")])], 1)])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };